<template>
    <modal
        :title="title | trans"
        @close="$emit('cancel')">
        <div class="pt-5 pb-8 text-lg sm:text-xl text-muted-500 font-normal" v-html="message"></div>
        <div class="flex items-center justify-end">
            <button @click="$emit('cancel')"
                    type="button"
                    class="bg-lightGrey-300 hover:bg-lightGrey-200 text-white py-2 px-4 rounded-lg">{{ cancel | trans }}</button>
            <button @click="confirm()"
                    type="button"
                    class="bg-primary-300 hover:bg-primary-100 text-white py-2 px-4 rounded-lg ml-3">{{ confirmBtn | trans }}</button>
        </div>
    </modal>
</template>

<script>
    import Modal from './Modal';

    export default {
        components: {
            Modal,
        },

        props: {
            message: String
        },

        computed: {
            title() {
                return {
                    'en': 'Confirm',
                    'es': 'Confirmar',
                };
            },
            confirmBtn() {
                return {
                    'en': 'Confirm',
                    'es': 'Confirmar',
                };
            },
            cancel() {
                return {
                    'en': 'Cancel',
                    'es': 'Cancelar',
                };
            },
        },

        methods: {
            confirm() {
                this.$emit('confirm');
            },
        },
    }
</script>
